/* ============================================================
   Project Gallery — bundle para Shopify.
   Los 6 archivos del handoff concatenados en su orden original y
   envueltos en un IIFE: ningun nombre (`$`, `track`, `render`,
   `view`, `cur`, `boot`...) se escapa al scope global, asi no
   pisa jQuery ni nada del theme.
   Generado por tools/build_52.py — no editar a mano.
   ============================================================ */
(function () {
'use strict';

/* ────── config.js ────── */
/* =============================================================
   config.js — todo lo configurable de la Project Gallery.
   Cambiar textos, opciones o rutas acá no requiere tocar la lógica.
   ============================================================= */

/* Ruta de la fuente de datos. En Shopify: cambiar por la URL del archivo
   (assets del tema / Shopify Files) o reemplazar loadProjects() en data.js. */
const DATA_URL = window.PG_DATA;

/* Resuelve el nombre de archivo contra la URL base de Shopify Content Files.
   La inyecta el template Liquid. Para volver a theme assets, cambiar
   `file_url` por `asset_url` en el template: aca no se toca nada. */
const ASSET = f => (window.PG_BASE || '') + f;

/* Variante de ancho N de una URL del CDN. */
const W = (u, n) => u + '?width=' + n;

/* La foto grande de la ficha se pide al ancho real de la pantalla (x2 en
   retina), topeado en 1200 que es el maximo del original. */
const FULLW = Math.min(1200, Math.round(Math.max(window.innerWidth || 800, 600)
                * Math.min(window.devicePixelRatio || 1, 2)));
const FU = d => W(d.full, FULLW);

/* Navegación de la cabecera — PENDIENTE DE DEFINICIÓN.
   href: null  → se muestra como texto sin link (como en el prototipo).
   href: '...' → se convierte en link real, con el mismo aspecto.
   hideBelow860: se oculta en pantallas de 860 px o menos (como en el prototipo).
   current: página actual (se resalta en naranja). */
const NAV = [
  { label: 'All Products',        href: null, hideBelow860: true,  current: false },
  { label: 'Customizer™',     href: null, hideBelow860: false, current: false },
  { label: 'Leather Making Kits', href: null, hideBelow860: true,  current: false },
  { label: 'Project Gallery',     href: null, hideBelow860: false, current: true  }
];

/* Velocidades del Customizer (botón naranja: 1 baja, 2 media, 3 alta).
   RPM según la Engraving Mastery Guide de Resparked. */
const SPEEDS = {
  1: { label: 'Low',    rpm: '5,000–15,000 RPM'  },
  2: { label: 'Medium', rpm: '15,000–18,000 RPM' },
  3: { label: 'High',   rpm: '18,000–25,000 RPM' }
};

/* Bits. La clave es la que se usa en projects.json (campo "bits") y en el
   ícono SVG <symbol id="b-CLAVE"> del index.html. */
const BITS = {
  pointy: 'Pointy',
  flame:  'Flame',
  ball:   'Ball',
  square: 'Square',
  burr:   'Carbide Burr'
};

/* Materiales que van siempre al final de los filtros (el resto, alfabético). */
const MATERIALS_LAST = ['Other'];

/* Frases de la banda naranja animada. */
const MARQUEE = [
  'Make. Spark. Repeat.',
  'One pen. Endless possibilities.',
  'Your hands, your spark.',
  'Joy over perfect.'
];


/* ────── analytics.js ────── */
/* =============================================================
   analytics.js — GANCHOS PREPARADOS, NO CONECTADOS.
   track() no hace nada salvo que exista window.resparkedTrack(event, props)
   o window.dataLayer (Google Tag Manager). Ver README §15.
   ============================================================= */
function track(event, props = {}) {
  try {
    if (typeof window.resparkedTrack === 'function') window.resparkedTrack(event, props);
    else if (Array.isArray(window.dataLayer)) window.dataLayer.push({ event, ...props });
  } catch (e) { /* analytics nunca debe romper la página */ }
}


/* ────── data.js ────── */
/* =============================================================
   data.js — capa de datos. La interfaz no conoce ningún proyecto:
   todo sale de DATA_URL. Para cambiar la fuente (Shopify, CMS),
   alcanza con que loadProjects() devuelva la misma forma.
   ============================================================= */
let PROJECTS = [];   // proyectos publicados, en orden
let MATERIALS = [];  // materiales derivados de los datos

async function loadProjects() {
  const res = await fetch(DATA_URL);
  if (!res.ok) throw new Error('Could not load ' + DATA_URL);
  const json = await res.json();
  PROJECTS = (json.projects || [])
    .filter(p => (p.status || 'published') === 'published')
    .sort((a, b) => (a.order ?? 0) - (b.order ?? 0))
    /* forma interna corta que usa la interfaz */
    .map(p => ({
      id: p.id, t: p.title, m: p.material, desc: p.description || '',
      sp: p.speed, bits: p.bits || [], by: p.credit || '',
      img: ASSET(p.image.card), full: ASSET(p.image.full), featured: !!p.featured
    }));
  MATERIALS = [...new Set(PROJECTS.map(d => d.m))].sort((a, b) => {
    const la = MATERIALS_LAST.includes(a), lb = MATERIALS_LAST.includes(b);
    return la !== lb ? (la ? 1 : -1) : a.localeCompare(b);
  });
}


/* ────── gallery.js ────── */
/* =============================================================
   gallery.js — cabecera, contadores, filtros, búsqueda y grilla.
   ============================================================= */
const ROOT = document.querySelector('.pg-root');
const $ = id => document.getElementById('pg-' + id);
const esc = s => String(s).replace(/[&<>"]/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
let activeMaterial = 'All';
let view = [];   // lista filtrada actual (la usa también el modal)

function paintNav() {
  if (!$('nav')) return;   /* el header lo pone el theme */
  $('nav').innerHTML = NAV.map(n => {
    const inner = n.href ? `<a href="${esc(n.href)}"${n.current ? ' aria-current="page"' : ''}>${esc(n.label)}</a>` : esc(n.label);
    if (n.current) return `<b>${inner}</b>`;
    return `<span${n.hideBelow860 ? ' class="hide"' : ''}>${inner}</span>`;
  }).join('');
}

function paintCounts() {
  const vals = { projects: PROJECTS.length, materials: MATERIALS.length };
  ROOT.querySelectorAll('[data-count]').forEach(el => el.textContent = vals[el.dataset.count]);
  ROOT.querySelectorAll('[data-tpl]').forEach(el => {
    el.lastChild.nodeValue = el.dataset.tpl.replace(/\{(\w+)\}/g, (_, k) => vals[k]);
  });
}

function paintFilters() {
  const filters = $('filters');
  ['All', ...MATERIALS].forEach(m => {
    const b = document.createElement('button');
    b.type = 'button'; b.className = 'pg-chip'; b.textContent = m;
    b.onclick = () => { activeMaterial = m; track('material_filtered', { material: m }); render(); };
    filters.appendChild(b);
  });
  let qTimer;
  $('q').oninput = () => {
    render();
    clearTimeout(qTimer);
    const q = $('q').value.trim();
    if (q.length >= 2) qTimer = setTimeout(() => track('search_performed', { query: q }), 800);
  };
}

function render() {
  [...$('filters').children].forEach(b => b.setAttribute('aria-pressed', b.textContent === activeMaterial));
  const q = $('q').value.trim().toLowerCase();
  view = PROJECTS.filter(d =>
    (activeMaterial === 'All' || d.m === activeMaterial) &&
    (!q || (d.t + ' ' + d.m + ' ' + d.by + ' ' + d.desc).toLowerCase().includes(q)));
  const grid = $('grid');
  grid.innerHTML = '';
  view.forEach((d, i) => {
    const el = document.createElement('button');
    el.type = 'button'; el.className = 'pg-card';
    el.onclick = () => openProject(i);
    el.innerHTML = `<div class="pg-ph"><img src="${esc(W(d.img,700))}" srcset="${esc(W(d.img,350))} 350w, ${esc(W(d.img,550))} 550w, ${esc(W(d.img,700))} 700w" sizes="(max-width:720px) calc(50vw - 23px), (max-width:1040px) calc(33.3vw - 26px), 275px" width="700" height="700" alt="Engraved ${esc(d.t.toLowerCase())}" loading="lazy" onerror="this.onerror=null;this.removeAttribute('srcset');this.src=window.PG_PLACEHOLDER"></div><div class="pg-cbody"><h3>${esc(d.t)}</h3><div class="pg-meta">${d.by ? 'by ' + esc(d.by) : esc(d.m)}</div><div class="pg-view">View project →</div></div>`;
    grid.appendChild(el);
  });
  if (!view.length) grid.innerHTML = '<div class="pg-empty">No projects match these filters yet.</div>';
  $('count').textContent = view.length + (view.length === 1 ? ' project' : ' projects');
}


/* ────── modal.js ────── */
/* =============================================================
   modal.js — ficha del proyecto: foto completa, velocidad,
   bits y navegación anterior/siguiente (flechas, teclado, swipe).
   ============================================================= */
const imgCache = {};
let cur = 0;

function preload(d) {
  if (d && !imgCache[FU(d)]) { const im = new Image(); im.src = FU(d); imgCache[FU(d)] = im; }
}

function openProject(i, via) {
  try { window.getSelection().removeAllRanges(); } catch (e) {}
  const dlg = $('dlg');
  cur = (i + view.length) % view.length;
  const d = view[cur];
  const img = $('dimg');
  /* Primero la foto chica (ya cargada) y después la grande, para que abra al instante. */
  const full = imgCache[FU(d)];
  img.src = (full && full.complete) ? FU(d) : W(d.img,700);
  if (!(full && full.complete)) {
    const im = new Image();
    im.onload = () => { if (view[cur] === d) img.src = FU(d); };
    im.src = FU(d); imgCache[FU(d)] = im;
  }
  img.onerror = () => { img.onerror = null; img.src = window.PG_PLACEHOLDER; };
  img.alt = 'Engraved ' + d.t.toLowerCase();
  $('dtitle').textContent = d.t;
  $('dmat').textContent = d.m;
  $('ddesc').textContent = d.desc;
  $('dby').textContent = d.by ? ('by ' + d.by) : '';
  $('dspeeds').innerHTML = Object.keys(SPEEDS).map(k => `<span class="${+k === d.sp ? 'pg-on' : ''}">${k}</span>`).join('');
  $('dspd').textContent = 'Speed ' + d.sp + ' · ' + SPEEDS[d.sp].label;
  $('drpm').textContent = SPEEDS[d.sp].rpm;
  $('dbits').innerHTML = Object.keys(BITS).map(k =>
    `<div class="pg-bit ${d.bits.includes(k) ? 'pg-on' : ''}"><svg viewBox="0 0 20 64"><use href="#pg-b-${k}"/></svg>${BITS[k]}</div>`).join('');
  if (!dlg.open) { dlg.showModal(); dlg.focus(); track('project_opened', { id: d.id, material: d.m }); }
  else track('project_navigated', { id: d.id, via: via || 'arrow' });
  preload(view[(cur + 1) % view.length]);
  preload(view[(cur - 1 + view.length) % view.length]);
}

function wireModal() {
  const dlg = $('dlg');
  $('close').onclick = () => dlg.close();
  dlg.addEventListener('click', e => { if (e.target === dlg) dlg.close(); });
  ['prev', 'next'].forEach(id => $(id).addEventListener('mousedown', e => e.preventDefault()));
  dlg.addEventListener('dblclick', () => { const s = window.getSelection && window.getSelection(); if (s) s.removeAllRanges(); });
  $('prev').onclick = () => openProject(cur - 1, 'arrow');
  $('next').onclick = () => openProject(cur + 1, 'arrow');
  document.addEventListener('keydown', e => {
    if (!dlg.open) return;
    if (e.key === 'ArrowRight') openProject(cur + 1, 'keyboard');
    if (e.key === 'ArrowLeft') openProject(cur - 1, 'keyboard');
  });
  let tx = null;
  dlg.addEventListener('touchstart', e => { tx = e.touches[0].clientX; }, { passive: true });
  dlg.addEventListener('touchend', e => {
    if (tx == null) return;
    const dx = e.changedTouches[0].clientX - tx;
    if (Math.abs(dx) > 60) openProject(cur + (dx < 0 ? 1 : -1), 'swipe');
    tx = null;
  });
}


/* ────── app.js ────── */
/* =============================================================
   app.js — arranque.
   ============================================================= */
function paintMarquee() {
  const seq = MARQUEE.map(w => esc(w) + '<i></i>').join('');
  $('mq').innerHTML = seq + seq + seq + seq;
}

async function boot() {
  paintNav();
  paintMarquee();
  wireModal();
  try { await loadProjects(); }
  catch (err) {
    $('grid').innerHTML = '<div class="pg-empty">Could not load the projects.</div>';
    return;
  }
  paintCounts();
  paintFilters();
  render();
}
if (document.readyState === 'loading')
  document.addEventListener('DOMContentLoaded', boot);
else boot();

})();
